// Axios instance and types
import http from '../api'
import { Filters, APIPaginatedResponse, Pagination, APIResponse } from '../types'
import { getRequestParamString } from '../utils/utils'
import { TypeUserRole } from './types'
import { toRoleWritePayload } from './rolePayload'

const apiPath = import.meta.env.VITE_API_PATH

async function getRoles(filters?: Partial<Filters>, pagination?: Partial<Pagination>) {
  return await http.get<APIPaginatedResponse<any>>(
    apiPath + 'auth/role-permissions/roles' + getRequestParamString(filters, pagination),
  )
}

async function createUserRole(input: TypeUserRole) {
  return await http.post<APIResponse<any>>(apiPath + 'auth/role-permissions/roles', toRoleWritePayload(input))
}

async function getRolePermissions(role_id: number) {
  // return await http.get<APIPaginatedResponse<any>>(apiPath + 'auth/role-permissions/roles/' + role_id)
  return await http.get<APIPaginatedResponse<any>>(apiPath + 'auth/user-business-modules/' + role_id)
}

async function getRoleOffPermissions() {
  // return await http.get<APIPaginatedResponse<any>>(apiPath + 'auth/role-permissions/roles/permissions/off')
  return await http.get<APIPaginatedResponse<any>>(apiPath + 'auth/user-business-modules')
}

async function updateUserRole(input: TypeUserRole) {
  return await http.put<APIResponse<any>>(
    apiPath + 'auth/role-permissions/roles/' + input.id,
    toRoleWritePayload(input),
  )
}

async function deleteUserRole(role_id: number) {
  return await http.delete<APIResponse<any>>(apiPath + 'auth/role-permissions/roles/' + role_id)
}

export default {
  getRoles,
  createUserRole,
  updateUserRole,
  getRolePermissions,
  getRoleOffPermissions,
  deleteUserRole,
}
